var map = {
	"./1.png": "3c38",
	"./10.png": "7093",
	"./11.png": "d6bf",
	"./12.png": "1b68",
	"./2.png": "9019",
	"./3.png": "0674",
	"./4.png": "34b4",
	"./5.png": "42ab",
	"./6.png": "7e38",
	"./7.png": "d94c",
	"./8.png": "08de",
	"./9.png": "8c14",
	"./full_segmented.png": "1ffe",
	"./relvado_en.jpg": "68af",
	"./relvado_es.jpg": "304f",
	"./relvado_fr.jpg": "cd4e",
	"./relvado_pt.jpg": "fcb0",
	"./separados/1.png": "b6d6",
	"./separados/10.png": "7d65",
	"./separados/11.png": "de8c",
	"./separados/12.png": "1534",
	"./separados/2.png": "f947",
	"./separados/3.png": "4dcc",
	"./separados/4.png": "a598",
	"./separados/5.png": "8c5a",
	"./separados/6.png": "9146",
	"./separados/7.png": "31a0",
	"./separados/8.png": "822b",
	"./separados/9.png": "ebaf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b960";